module.exports = __webpack_public_path__ + "img/Journalism02.15288591.png";